import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.array.index-of.js";
var _loaderPath = '/app/cdp-site/static/images/common/loader.svg';
var _loaderType = 'img';
var GenericalLoader = /*#__PURE__*/function () {
  /**
   *
   * @param {String} prmLoader your loader, default will be loader URL of cdp-site
   * @param {String} prmType can be img url or svg, default img
   */
  function GenericalLoader() {
    var prmLoader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _loaderPath;
    var prmType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _loaderType;
    _classCallCheck(this, GenericalLoader);
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    if (isIE11 && prmLoader.indexOf(_loaderPath) !== -1) {
      this.loader = '/app/cdp-site/static/images/common/loader.gif';
    } else {
      this.loader = prmLoader;
    }
    this.type = prmType;
  }

  /**
   *
   * @param {Node} prmNode the Node where you want to append your loader
   */
  return _createClass(GenericalLoader, [{
    key: "append",
    value: function append(prmNode) {
      var htmlGeneration = '';
      switch (this.type) {
        case 'img':
          htmlGeneration = "<img alt=\"Chargement\" class=\"js-generical-loader\" src=\"".concat(this.loader, "\"/>");
          break;
        case 'svg':
          htmlGeneration = "<div class=\"js-generical-loader\">".concat(this.loader, "</div>");
          break;
        default:
          htmlGeneration = "<img alt=\"Chargement\" class=\"js-generical-loader\" src=\"".concat(this.loader, "\"/>");
          break;
      }
      prmNode.insertAdjacentHTML('beforeend', htmlGeneration);
    }

    /**
     *
     * @param {Node} prmNode the Node where you want to remove your loader
     */
  }, {
    key: "remove",
    value: function remove(prmNode) {
      prmNode.removeChild(prmNode.querySelector('.js-generical-loader'));
    }
  }]);
}();
export { GenericalLoader as default };